//
import * as React from 'react';
import '../../css/menu.css';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAPICall } from '../../hooks/useAPICall';

export function SecurityElement(pageData) {

    const navigate = useNavigate();
    const [timeLeft, setTimeLeft] = useState(9999999999);

    let tick = setTimeout(showExpiry, 1000);


    function showExpiry() {

        let diff = Math.trunc((sessionStorage.getItem('Expiry') - Date.now()) / 1000);
        if(diff <= 0)
        {
            let el = document.getElementById("timeoutbox");
            if (el) {
                el.style.visibility = 'hidden';
            }
            clearTimeout(tick);
            navigate("/Logout");
        }
        else{
        if (diff <= 20) {
            setTimeLeft(diff);
            let el = document.getElementById("timeoutbox");
            if (el) {
                if(el.style.visibility !== 'visible')
                {
                    el.style.visibility = 'visible';
                }
            }
            
        }
        tick = setTimeout(showExpiry, 1000);
    }
     
    }


    const { MakeCall } = useAPICall();

    async function handleRenewComplete(data) {
        
        let el = document.getElementById("timeoutbox");
        if (el) {
            el.style.visibility = 'hidden';
        }
    }

    async function handleRenew() {
        MakeCall('login/renew', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleRenewComplete, true);
    }

    


    function RenderTimeOut() {
        return (

            <div className='rendertimeout' id="timeoutbox">
                <p>Your session is about to expire! Do you want to stay logged in?</p>
                <p>{timeLeft}</p>
                <button className='prcbtn' type='button' id="stayloggedin" onClick={handleRenew}>Stay Logged In</button>
            </div>
        );
    }

    return (
        <>

            {RenderTimeOut()}
        </>
    );
}












